import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "./rest-common.service";
import { Observable } from "rxjs";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class UserService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }
  public resource_url = `${this.BASE_API_URL}/platform/users/`;

  getViziblVersion(){
    return this.get(`${this.BASE_API_URL}/sys/version`)
  }

  getIframeObject(){
    return this.get(`${this.BASE_API_URL}/sys/qlik-settings`)
  }

  getClientMetaData(params){
    let url = this.buildUrl(`${this.BASE_API_URL}/client-profile/meta/`, '', params)
    return this.get(url);
  }

  getAdspCurrency(params = {}){
    let url = this.buildUrl(`${this.BASE_API_URL}/client-profile/adsp-settings/`, '', params)
    return this.get(url);
  }

  getClientSettingData(params){
      let url = this.buildUrl(`${this.BASE_API_URL}/client-profile/settings/`, '', params)
    return this.get(url);
  }

  getTimeZones(){
    return this.get(`${this.BASE_API_URL}/sys/timezones`)
  }

  getDayPartTimeZones(){
    return this.get(`${this.BASE_API_URL}/sys/day-part-timezones`)
  }

  getUserData() {
    return this.get(`${this.BASE_API_URL}/user/permissions`)
  }

  getAccountDetails(){
    return this.get(`${this.BASE_API_URL}/user/account-details`)
  }

  getCurrencyOptions(){
    return this.get(`${this.BASE_API_URL}/sys/currencies`)
  }

  updateOwnPassword(email) {
    return this.post(`${this.BASE_API_URL}/user/password-change/`, email)
  }

  changeUserPassword(passwords: any): Observable<any> {
    return this.put(`${this.BASE_API_URL}/password-reset-complete/`, passwords);
  }

  associateClients(id, clients, params = {}) {
    return this.put(this.buildUrl(`${this.resource_url}${id}/associate/`, '', params), clients)
  }

  updateUserData(data){
    let url = `${this.BASE_API_URL}/user/${data.user_id}/`
    return this.put(url,data)
  }

  createPgSession(data, params){
    let params_url = this.convertToString(params)
    let url =  `${this.BASE_API_URL}/payment-gateway/create-pg-session/?${params_url}`
    return this.post(url, data)
  }

  totalPayableAmount(data, params){
    let params_url = this.convertToString(params)
    let url =  `${this.BASE_API_URL}/payment-gateway/get-pg-charges/?${params_url}`
    return this.post(url, data)
  }

  addFunds(data, tid, params){
    let params_url = this.convertToString(params)
    return this.put(`${this.BASE_API_URL}/payment-gateway/${tid}/add-funds/?${params_url}`, data)
  }

  cancel_payment(data, tid, params){
    let params_url = this.convertToString(params)
    return this.put(`${this.BASE_API_URL}/payment-gateway/${tid}/cancel-payment/?${params_url}`, data)
  }

  getPlatformUserRoles() {
    return this.get(`${this.BASE_API_URL}/platform/users/roles`)
  }
}
